import { useMutation } from "@tanstack/react-query";
import { uploadServices } from "./upload.services";

export const useUploadImages = () => {
  return useMutation({
    mutationFn: uploadServices.uploadImages,
  });
};

export const useUpdateImage = () => {
  return useMutation({
    mutationFn: ({
      id,
      updateData,
    }: {
      id: string;
      updateData: {
        staffId?: string;
        name?: string;
        url?: string;
        size?: string;
        inventoryId?: string;
      };
    }) => uploadServices.updateImage(id, updateData),
  });
};

export const useGetPresignedUrl = () => {
  return useMutation({
    mutationFn: uploadServices.getPresignedUrl,
  });
};

export const useGetPresignedUrls = () => {
  return useMutation({
    mutationFn: uploadServices.getPresignedUrls,
  });
};

export const useUploadFileToPresignedUrl = () => {
  return useMutation({
    mutationFn: ({
      presignedUrl,
      file,
    }: {
      presignedUrl: string;
      file: File;
    }) => uploadServices.uploadFileToPresignedUrl(presignedUrl, file),
  });
};
